import { GET_LOGIN_USER } from "../../Type"

const initial = {
    LoginUser: [],
    loading: true,
}

const LoginReducer = (state = initial, action) => {
    switch (action.type) {
        case GET_LOGIN_USER:
            return {
                ...state,
                LoginUser: action.payload,
                loading: false
            }
        default:
            return state;
    }
}

export default LoginReducer